// eslint-disable-next-line no-shadow
export enum Position {
  TOP = 'top',
  TOP_LEFT = 'top-start',
  TOP_RIGHT = 'top-end',
  BOTTOM = 'bottom',
  BOTTOM_LEFT = 'bottom-start',
  BOTTOM_RIGHT = 'bottom-end',
  LEFT = 'left',
  LEFT_TOP = 'left-start',
  LEFT_BOTTOM = 'left-end',
  RIGHT = 'right',
  RIGHT_TOP = 'right-start',
  RIGHT_BOTTOM = 'right-end',
}

export type PositionType =
  | 'top'
  | 'top-start'
  | 'top-end'
  | 'bottom'
  | 'bottom-start'
  | 'bottom-end'
  | 'left'
  | 'left-start'
  | 'left-end'
  | 'right'
  | 'right-start'
  | 'right-end'
